'use strict';

import modalDirective from 'brg/rest/buttons/modal';

import template from './template.html';

export default modalDirective({
	template: template,
	controller: controller,
});


function controller($scope, $http) {
	'ngInject';

	$scope.submitting = false;
	$scope.errors = null;

	$scope.submitData = function() {
		if ($scope.submitting) return;
		$scope.submitting = true;
		const url = '/api/teams/beats/create/';
		const data = {
			name: $scope.name,
			description: $scope.description || '',
		};
		if ($scope.reserveList) {
			data.reserve_list_id = $scope.reserveList.uuid;
		}
		$http({
			method: 'POST',
			url: url,
			data: data,
		}).then((response) => {
			$scope.$close(response.data);
		}, (error) => {
			console.error(error);
			$scope.errors = error.data;
		}).finally(() => {
			$scope.submitting = false;
		});
	}
}
